<template>
  <div class="container">
    <div class="row-box">
      <van-row gutter="30">
        <van-col span="24">
          <div class="rev_box">
            <div class="please">请您对我们的服务给予评价</div>
            <div class="windows">{{ reviewsdata.window_title }}</div>
            <div class="number" />
            <div class="type_box">
              <van-row type="flex" justify="center" gutter="20">
                <van-col span="6">
                  <div class="type_list" :class="{active:shows==1}" @click="onSubmit('1')">
                    <span class="pj_list"><img src="../../assets/good.png"></span>
                    <span class="pj_tit">好评</span>
                  </div>
                </van-col>
                <van-col span="6">
                  <div class="type_list" :class="{active:shows==2}" @click="onSubmit('2')">
                    <span class="pj_list"><img src="../../assets/middle.png"></span>
                    <span class="pj_tit">中评</span>
                  </div>
                </van-col>
                <van-col span="6">
                  <div class="type_list" :class="{active:shows==3}" @click="onSubmit('3')">
                    <span class="pj_list"><img src="../../assets/bad.png"></span>
                    <span class="pj_tit">差评</span>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { getEvaluate, postEvaluate } from '@/api/data'
import { Form, Button, Field, Image as VanImage, Col, Row, Toast, Swipe, SwipeItem } from 'vant'

export default {
  name: 'ReviewIndex',
  components: {
    [Form.name]: Form,
    [Button.name]: Button,
    [Field.name]: Field,
    [VanImage.name]: VanImage,
    [Col.name]: Col,
    [Row.name]: Row,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Toast.name]: Toast
  },
  data() {
    return {
      status: '',
      timer: '',
      otherQuery: {},
      loading: false,
      reviewsdata: '',
      listQuery: {
        sysset_id: '',
        window_id: ''
      },
      shows: ''
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.timer = setInterval(this.getEvaluate, 60000)
  },
  created() {
    if (this.$route.query.sysset_id && this.$route.query.window_id) {
      this.listQuery.sysset_id = this.$route.query.sysset_id
      this.listQuery.window_id = this.$route.query.window_id
      this.getEvaluate()
    } else {
      Toast.fail({
        message: '地址错误，请重新输入！',
        forbidClick: true,
        overlay: true,
        duration: 0
      })
    }
  },
  updated() {
  },
  methods: {
    openSound() {
      var myVideo = document.getElementById('video1')
      myVideo.muted = false
    },
    async getEvaluate() {
      // this.$toast.loading({ message: '加载中' })
      const { data } = await getEvaluate(this.listQuery)
      // console.log(data)
      this.reviewsdata = data
      this.status = data.status
      // this.$toast.clear()
      if (this.status === '-1') {
        Toast.fail({
          message: '暂停挂号 ',
          forbidClick: true,
          overlay: true,
          duration: 0
        })
      }
      if (this.status === '-2') {
        Toast.fail({
          message: '停止挂号 ',
          forbidClick: true,
          overlay: true,
          duration: 0
        })
      }
    },
    onSubmit(type) {
      this.shows = type
      this.listQuery.type = type
      postEvaluate(this.listQuery).then((response) => {
        this.data = response
        Toast({
          type: 'success',
          message: '评价成功',
          forbidClick: true,
          onClose: () => {
            this.shows = ''
          }
        })
      }).catch(err => {
        Toast({
          type: 'fail',
          message: err.message,
          forbidClick: true,
          onClose: () => {
            this.shows = ''
          }
        })
      })
    },
    playPause() {
      var myVideo = document.getElementById('video1')
      if (myVideo.paused) {
        myVideo.play()
        document.getElementById('stop').style.display = 'none'
      } else {
        myVideo.pause()
        document.getElementById('stop').style.display = 'block'
      }
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    background: linear-gradient(135deg, #5397FF 0%, #5C42FC 100%);
    min-height: 100vh;
    position: relative;
  }
  .row-box{
    width: calc(100% - 20px);
    margin: 20px 10px 10px 10px;
    float: left;
    height: calc(100vh - 30px)
  }
  /deep/ .van-row{height: 100%;}
  /deep/ .van-col{height: 100%;}
  .video{
    width: 100%;
    height: calc(100vh - 30px);
    float: left;
  }
  .video img{
    width: 100%;
    height: calc(100vh - 30px);
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
  }
  .video .video_zz{
    width: 100%;
    float: left;
    height: 100%;
    z-index: 9999;
  }
  .video .video-box{
    width: 100%;
    height: 100%;
    /*background: #333333;*/
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
  }

  .video .play_box{ width: 100%; height: 100%;position: relative;left: 0px;top: -100%;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  .play_box img{width: calc(10vh);height: calc(10vh);display: none}
  .rev_box{
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #769BFE 0%, #7B67FC 100%);
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
    color: #FFFFFF;
    text-align: center;
  }
  .please{width: 100%;float: left; height: 20px; margin-top: 10px; line-height: 20px;font-size: 16px;}
  .windows{width: 100%;float: left;height: calc(15vh);line-height: calc(15vh);font-size: 30px;margin-top: 10px;}
  .number{width: 100%;float: left;height:  calc(10vh);line-height: calc(10vh);font-size: 8px;margin-top: 5px;}
  .type_box{width: 100%;float: left;height:calc(25vh);line-height: calc(25vh); margin-top: 5px;}
  .type_list{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // float: left;
    height: 50%;
    // margin: 0 15%;
    background: #AFABFD;
    border-radius:5px;
  }
  .pj_list{
    width: 50%;
    height: 50%;
    line-height:25px;
    float: left;
    margin: 0 25%;
    font-size: 8px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #101112;
  }
  .pj_list img{
    width: 100%;
    margin-top: 5px;
  }
  .pj_tit{
    width: 50%;
    // height: 50%;
    line-height:25px;
    margin-top: 2px;
    // float: left;
    // margin: 0 25%;
    font-size: 16px;
    text-align: center;
    color: #101112;
  }
  .active{background: #FFF746}
  /deep/ .van-swipe{
    border-radius:5px;
    -webkit-border-radius:5px;
    -moz-border-radius:5px;
  }

</style>
